import { CustomerMessageDownload } from '@codefluegel/wowis-rest-typescript-client';
import { makeAutoObservable } from 'mobx';
import moment from 'moment';

export default class MessageStore {
  messages: CustomerMessageDownload[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setMessages(messages: CustomerMessageDownload[]) {
    this.messages = messages.sort(
      (a, b) => moment(b.createdAt).valueOf() - moment(a.createdAt).valueOf(),
    );
  }

  updateMessageReadStatus(messageId: number, isRead: boolean) {
    this.messages = this.messages.map(msg =>
      msg.messageId === messageId ? { ...msg, isRead } : msg,
    );
  }
}
